import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';
import { POLL_KEYS } from '@/api/usePolls';
import { POLL_DETAIL_KEYS } from '@/api/usePoll';

import type { Poll, CreatePollPayload, UpdatePollPayload } from '@/types/poll';

export function useCreatePoll() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: CreatePollPayload) => {
            const { data } = await api.post<Poll>(API_ROUTES.polls, payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: POLL_KEYS.all });
            toast.success('Encuesta publicada!');
        },
        onError: () => {
            toast.error('No se pudo crear la encuesta. Intenta de nuevo.');
        },
    });
}

export function useUpdatePoll(pollSlug: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: UpdatePollPayload) => {
            const { data } = await api.patch<Poll>(API_ROUTES.pollDetail(pollSlug), payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: POLL_DETAIL_KEYS.detail(pollSlug) });
            queryClient.invalidateQueries({ queryKey: POLL_KEYS.all });
            toast.success('Encuesta actualizada');
        },
        onError: () => {
            toast.error('No se pudo actualizar la encuesta.');
        },
    });
}

export function useDeletePoll() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (pollSlug: string) => {
            await api.delete(API_ROUTES.pollDetail(pollSlug));
            return pollSlug;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: POLL_KEYS.all });
            toast.success('Encuesta eliminada');
        },
        onError: () => {
            toast.error('No se pudo eliminar la encuesta.');
        },
    });
}
